<template>
    <component :is="template">
        <v-container v-if="loading">
            <div class="contents-area">
                <div class="tit-wrap tit-wrap--unberline">
                    <h2 class="tit">이벤트</h2>
                </div>
                <div class="contents-area__inner">
                    <div class="my-md-n10px">
                        <v-row>
                            <v-col cols="6" md="4" v-for="board in boards" :key="board._id">
                                <div class="py-md-10px cursor-pointer event-card" @click="rows(board)">
                                    <div class="border">
                                        <v-img :src="board.thumb" max-width="500" :aspect-ratio="500/500" contain class="event-card__image" />
                                    </div>
                                    <div class="text-center py-12px py-md-16px">
                                        <div class="tit tit--xs text-truncate" >{{ board.subject }}</div>
                                        <div class="font-size-16 font-size-md-18 mt-6px">{{ `${$dayjs(board.display.startDate).format("YYYY.MM.DD")} ~ ${board.display.endDate ? $dayjs(board.display.endDate).format("YYYY.MM.DD") : "상시진행"}` }}</div>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </div>
                <div class="tit-wrap tit-wrap--unberline"></div>
                <div class="contents-area__inner">
                    <router-board code="event" skin="event" />
                </div>
            </div>
        </v-container>
    </component>
</template>
<script>
import api from "@/api";
import RouterBoard from "@/components/client/board/router-board.vue";
export default {
    components: {
        RouterBoard,
    },
    async mounted() {
        this.loading = false;
        await this.init()
        this.loading = true;
    },
    data() {
        return {
            loading: false,
            boards: []
        }
    },
    methods: {
        async init() {
            let { boards } = await api.v1.boards.gets({
                headers: {
                    code: "event",
                    skip: 0,
                    limit: 0
                },
                params: { status: "open" }
            })
            this.boards = boards
        },
        rows(board) {
            if(board?.url) {
                this.$router.push(board?.url)
            } else {
                this.$router.push(`/board/event/${board?._id}`)
            }
        },
    },
    computed: {
        template(){ return () => import(`@/templates/${this.$theme.pages.default}`); }
    },
}
</script>